/**
 * High level router.
 *
 * Note: It's recommended to compose related routes in internal router
 * components (e.g: `src/app/modules/Auth/pages/AuthPage`, `src/app/BasePage`).
 */

import React from "react";
import { shallowEqual, useSelector } from "react-redux";
import { Redirect, Route, Switch } from "react-router-dom";
import { Layout } from "../_metronic/layout";
import BasePage from "./BasePage";
import { AuthPage } from "./modules/Auth";
// import ErrorsPage from "./modules/ErrorsExamples/ErrorsPage";
import { useLocation } from "react-router-dom";
import MannualApplicantPage from "./pages/mannual-applicant";
import { publicRoute } from "../data/publicRoute";
export function Routes({ handle }) {
  // const location = useLocation();
  // const params = new URLSearchParams(location.search);
  // console.log(params);
  const { authToken } = useSelector((state) => state.auth, shallowEqual);

  // const { isAuthorized } = useSelector(
  //   (state) => ({
  //     isAuthorized: state.auth != null,
  //   }),
  //   shallowEqual
  // );

  return (
    <Switch>
      {!authToken &&
      !publicRoute.includes(window.location.pathname.split("/")[1]) ? (
        /*Render auth page when user at `/auth` and not authorized.*/
        <Route>
          <AuthPage />
        </Route>
      ) : !authToken &&
        publicRoute.includes(window.location.pathname.split("/")[1]) ? (
        <Route path="/public-applicant" component={MannualApplicantPage} />
      ) : (
        /*Otherwise redirect to root page (`/`)*/
        <Redirect from="/auth" to="/" />
      )}

      {/* <Route path="/error" component={ErrorsPage} /> */}
      {/* <Route path="/logout" component={Logout} /> */}

      {/* {!authToken ? (
        <Redirect to="/auth/login" />
      ) : ( */}
        <Layout handle={handle}>
          <BasePage />
        </Layout>
      {/* )} */}
    </Switch>
  );
}
